import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';

import {
    submitSearchFacet,
    toggleVisibleDropdownMenu,
} from '../Actions/FacetedSearch.action';

// Filter groups beyond visibleGroupCount are hidden until "show more filters" is clicked.
const visibleGroupCount = 3;

const FacetedSearchCompact = ({ facetFilters, onFacetChange }) => {
    const dispatch = useDispatch();
    const { visibleDropdownMenu } = useSelector((state) => state.facetedSearch);
    const [hidden, setHidden] = useState(true);
    const groups = (facetFilters || []).filter(
        (group) => group.options && group.options.length > 0
    );

    return (
        <ul className="faceted-search faceted-search--compact">
            {groups.map(
                    (group, groupIndex) => (
                            <li
                                className={`faceted-search__group ${
                                    groupIndex >= visibleGroupCount && hidden
                                        ? 'faceted-search__group--hidden'
                                        : ''
                                }`}
                                key={`${group.label}-${groupIndex}`}
                            >
                                <div
                                    className={`faceted-search__group-header ${
                                        visibleDropdownMenu.includes(group.id)
                                            ? 'faceted-search__group-header--show-compact'
                                            : ''
                                    }`}
                                    role="faceted-search-item-group"
                                    onClick={(event) =>
                                        dispatch(
                                            toggleVisibleDropdownMenu(group)
                                        )
                                    }
                                >
                                    {group.label}
                                </div>
                                <div className="faceted-search__sublist-wrapper">
                                    <ul className="faceted-search__sublist">
                                        {group.options &&
                                            group.options.map(
                                                (item, itemIndex, array) => (
                                                    <li
                                                        key={`${item.label}-${itemIndex}`}
                                                        className="faceted-search__item"
                                                        role="faceted-search-item"
                                                    >
                                                        <FacetedFilterCheckbox
                                                            item={item}
                                                            group={group}
                                                            onFacetChange={
                                                                onFacetChange
                                                            }
                                                        />
                                                    </li>
                                                )
                                            )}
                                    </ul>
                                    <button
                                        className="filter__button"
                                        onClick={(event) => {
                                            dispatch(
                                                toggleVisibleDropdownMenu(group)
                                            );
                                            dispatch(
                                                submitSearchFacet(facetFilters)
                                            );
                                        }}
                                    >
                                        {translate('general.select')}
                                    </button>
                                </div>
                            </li>
                        )
                )}
            {groups.length > visibleGroupCount && (
                <button
                    type="button"
                    className="faceted-search__show-more-btn"
                    onClick={() => setHidden(!hidden)}
                >
                    {translate(
                        hidden
                            ? 'category-navigation.show-filters'
                            : 'category-navigation.hide-filters'
                    )}
                </button>
            )}
        </ul>
    );
};

const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => (
    <label className="faceted-filter">
        <input
            className="faceted-filter__input"
            type="checkbox"
            onChange={(event) => onFacetChange(group, item)}
            checked={group.selectedOptions.includes(item.id)}
        />
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) && item.quantity > 0 && (
                <span className="faceted-filter__quantity">
                    {' '}
                    ({item.quantity})
                </span>
            )}
        </span>
    </label>
);

export default FacetedSearchCompact;
